module.exports = __webpack_public_path__ + "static/media/logo3.4f5ce561.png";